import React from 'react';
import { images } from 'ionic-ui';
import ResponsiveImage from '../../../../components/responsive-image/ResponsiveImage';

type Props = {
  logo?: string;
  banner?: string;
  storeName?: string;
};

export default function Header({ logo, banner, storeName }: Props) {
  const backgroundImage = banner || '/images/hero.png';
  return (
    <div
      className="relative w-full h-32 rounded-md overflow-hidden bg-center bg-cover"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Contrast overlay: heavier dark on the text side, fading toward the logo
          so the banner still reads as a personal touch on the right. */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#050b0f]/85 via-[#050b0f]/60 to-[#050b0f]/25" />

      <div className="relative h-full flex justify-between items-center">
        <div className="text-white flex-1 max-w-full md:max-w-[calc(100%-160px)] px-6">
          <h3 className="font-semibold truncate shadow-text">
            Welcome {storeName ?? ''},
          </h3>
          <p className="shadow-text">Sale globally, earn more.</p>
        </div>
        <div className="hidden md:block p-4">
          <div className="size-24 rounded-lg overflow-hidden ring-2 ring-white/40 shadow-lg bg-white/10 backdrop-blur-sm">
            <ResponsiveImage
              aspectRatio={1}
              src={logo || images.placeholder}
              alt="Store logo"
              className="rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
